import React from 'react'
import {
  Container,
  Image,
  Menu,
  Button,
} from 'semantic-ui-react'
import {
  Link,
  NavLink,
} from 'react-router-dom'
import logo from './cc.svg'

const PageHeader = ({mode, onModeChange}) => (
  <Menu fixed='top' inverted>
    <Container>
      <Menu.Item as={Link} to="/" header>
        <Image src={logo} style={{ height: '20px', marginRight: '1em' }} />
        Computing Curriculum
      </Menu.Item>
      <Menu.Item as={NavLink} to="/areas">Knowledge Areas</Menu.Item>
      <Menu.Item as={NavLink} to="/search">Search</Menu.Item>
      <Menu.Item>
        <Button.Group>
          <Button
            compact
            size='mini'
            color={mode==='view'?'blue':undefined}
            onClick={()=>onModeChange('view')}>
            Explore
          </Button>
          <Button
            compact
            size='mini'
            color={mode==='select'?'orange':undefined}
            onClick={()=>onModeChange('select')}>
            Select
          </Button>
          <Button
            compact
            size='mini'
            color={mode==='compare'?'yellow':undefined}
            onClick={()=>onModeChange('compare')}>
            Compare
          </Button>
        </Button.Group>
      </Menu.Item>
    </Container>
  </Menu>
)

export default PageHeader